import { useNavigate } from 'react-router-dom';
import Loader from '../../common/components/Loader';
import { useState } from 'react';
import {
    Box,
    Button,
    Paper,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import { ProfileService } from './Services/ProfileService';
import { NavigationRoutes } from '../../application/router/routes';

export default function ForgottenPassword() {
    const navigate = useNavigate();
    const profileService = new ProfileService();
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const handleEmail = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const _response = await profileService.passwordResetRequest(
                JSON.parse(localStorage.getItem('orgId')),
                email
            );
            setIsLoading(false);
            if (_response.success) {
                navigate(NavigationRoutes.login, {
                    state: {
                        message:
                            'Ett Email för att återställa ditt lösenord har skickats!',
                        type: 'success',
                    },
                    replace: true,
                });
            } else {
                navigate(NavigationRoutes.login, {
                    state: {
                        message:
                            'Något gick fel vid lösenordsåterställning. Skrev du in rätt Email?',
                        type: 'error',
                    },
                    replace: true,
                });
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Error during password reset:', error);
            navigate(NavigationRoutes.login, {
                state: {
                    message:
                        'Något gick fel vid lösenordsåterställning. Skrev du in rätt Email?',
                    type: 'error',
                },
                replace: true,
            });
        }
    };

    const handleCancel = () => {
        navigate(NavigationRoutes.login);
    };

    if (isLoading) {
        return <Loader />;
    }

    return (
        <div>
            <Box display="flex" justifyContent="center" padding={4}>
                <Stack
                    spacing={2}
                    alignItems="center"
                    sx={{ maxWidth: '400px', width: '100%' }}
                >
                    <Paper
                        elevation={3}
                        sx={{ padding: 4, borderRadius: 2, width: '100%' }}
                    >
                        <Typography variant="h4" align="center" gutterBottom>
                            Glömt lösenord?
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            align="center"
                            gutterBottom
                        >
                            Du kan skicka en begäran om att återställa ditt
                            lösenord om du glömt det genom att skriva in din
                            email adress i fältet nedan och sedan klicka på
                            "Skicka"
                        </Typography>

                        <Box
                            mt={2}
                            mb={2}
                            borderBottom={1}
                            borderColor="divider"
                        />

                        <Box
                            component="form"
                            onSubmit={handleEmail}
                            sx={{ mt: 1 }}
                        >
                            <TextField
                                label="Email"
                                variant="outlined"
                                type="email"
                                fullWidth
                                autoComplete="off"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                margin="normal"
                            />

                            <Stack
                                direction="row"
                                spacing={2}
                                justifyContent="center"
                                mt={3}
                            >
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    onClick={handleCancel}
                                    sx={{ minWidth: '120px' }}
                                >
                                    Tillbaka
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    sx={{ mt: 3, mb: 2 }}
                                >
                                    Skicka
                                </Button>
                            </Stack>
                        </Box>
                    </Paper>
                </Stack>
            </Box>
        </div>
    );
}
